export default __webpack_public_path__ + "static/media/ENABLEDCERT.df64c989.png";